import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormButton from '../../FormButton';
import { usePaymentInfoRows } from './usePaymentInfoRows';
import { PrimaryButton } from '../../Button';

const styles = {
  container: { height: '100%' },
  card: {
    bgcolor: '#fff',
    color: 'var(--font-color-primary)',
    p: '24px 24px 16px',
    mt: 'auto',
    borderRadius: '16px',
  },
  cardTitle: { fontSize: 20, textAlign: 'center', mb: '16px' },
  rowsContainer: { mb: '30px' },
  row: { height: 50, borderBottom: '1px solid #e6e6e6' },
  rowTitle: { fontSize: 14 },
  rowContent: { display: 'flex', fontSize: 14, fontWeight: 500, ml: 'auto' },
  donateButtonWrapper: { width: 'fit-content', ml: 'auto', mr: 'auto' },
  continueButtonWrapper: { mt: 'auto' },
};

function PaymentInfoCard({
  payment,
  donateAgainPath,
  nextPath,
  ctaButtonStyle,
}) {

  const rows = usePaymentInfoRows(payment);

  const goToNextBlock = () => {
    window.location.href = nextPath;
  };

  const goToFirstStep = () => {
    window.location.href = donateAgainPath;
  };

  return (
    <Stack justifyContent="center" sx={styles.container}>
      <Box sx={styles.card} data-testid="PaymentInfoCard/Container">
        <Box sx={styles.cardTitle}>Thank you for payment!</Box>
        <Box sx={styles.rowsContainer}>
          {rows.map(({ title, content }) => (
            <Stack
              key={title}
              sx={styles.row}
              direction="row"
              alignItems="center"
            >
              <Box sx={styles.rowTitle}>{title}</Box>
              <Box sx={styles.rowContent}> {content} </Box>
            </Stack>
          ))}
        </Box>
        <Box sx={styles.donateButtonWrapper}>
          <FormButton
            onClick={goToFirstStep}
            startIcon={<RefreshIcon />}
            variant="secondary"
          >
            Pay again
          </FormButton>
        </Box>
      </Box>
      <Box sx={styles.continueButtonWrapper}>
        <PrimaryButton
          aria-label="credit card submit"
          onClick={goToNextBlock}
          noMargin
          {...(ctaButtonStyle && ctaButtonStyle)}
        >
          Continue
        </PrimaryButton>
      </Box>
    </Stack>
  );
}

PaymentInfoCard.propTypes = {
  payment: PropTypes.shape({
    amount_cents: PropTypes.number,
    paid_at: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.instanceOf(Date),
    ]).isRequired,
    currency: PropTypes.string,
    status: PropTypes.string,
    stripe_card_brand: PropTypes.string,
    stripe_card_last4: PropTypes.string,
  }).isRequired,
  nextPath: PropTypes.string.isRequired,
  donateAgainPath: PropTypes.string.isRequired,
};

export default PaymentInfoCard;
